module.exports = __webpack_public_path__ + "img/pro_4.5df51adf.png";